// extracted by mini-css-extract-plugin
module.exports = {"PropertyKeyFiguresItem":"PropertyKeyFiguresItem_PropertyKeyFiguresItem__3_PpM"};